<template>
  <div>
   <div class="searchBox">
    <div class="searchLeft">
      <el-input
        size="medium"
        v-model="searchForm.nodeName"
        placeholder="请输入节点名称"
        @keyup.enter.native="getTableList"
      ></el-input>
      <el-button size="medium" type="primary" icon="el-icon-search" @click="getTableList">查询</el-button>
    </div>
   </div>
   <el-table
    border
    :data="tableData"
    height="73vh"
    style="width: 100%">
    <el-table-column
      prop="nodeNumber"
      label="节点编号">
    </el-table-column>
    <el-table-column
      prop="nodeName"
      label="节点名称">
    </el-table-column>
    <el-table-column
      prop="maxPower"
      label="全部算力">
      <template slot-scope="scope">
        <span>{{$selfFunc.toNonExponential(scope.row.maxPower,4)}}</span>
      </template>
    </el-table-column>
    <el-table-column
      prop="soldPower"
      label="已销售算力">
      <template slot-scope="scope">
        <span>{{$selfFunc.toNonExponential(scope.row.soldPower,4)}}</span>
      </template>
    </el-table-column>
    <el-table-column
      prop="beSalePower"
      label="待销售算力">
      <template slot-scope="scope">
        <span>{{$selfFunc.toNonExponential(scope.row.beSalePower,4)}}</span>
      </template>
    </el-table-column>
    <el-table-column
      label="是否封装">
      <template slot-scope="scope">
          <div>
          {{scope.isDelCheck==1?'是': '否'}}
        </div>
      </template>
    </el-table-column>
    <el-table-column
      label="是否销售">
      <template slot-scope="scope">
        <div>
          {{scope.isSellCheck==1?'是': '否'}}
        </div>
      </template>
    </el-table-column>
    <el-table-column
      prop="createTime"
      label="创建时间">
      <template slot-scope="scope">
        <span>{{$selfFunc.dayjsFunc(scope.row.createTime)}}</span>
      </template>
    </el-table-column>
  </el-table>
  <div class="pageBox" v-if="totalNum > 0">
    <el-pagination
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="searchForm.page"
      :page-sizes="[20, 50, 100, 500]"
      :page-size="searchForm.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="totalNum"
    >
    </el-pagination>
  </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      totalNum:0,
      searchForm:{
        page:1,
        pageSize:20,
        nodeName: ''
      },
      
      options: [
        {
          name: '全部',
          value: ''
        },
        {
          name: '待封装',
          value: '2'
        },
        {
          name: '已完成',
          value: '1'
        },
        // {
        //   name: '已取消',
        //   value: '3'
        // }
      ],
      tableData: [],
      dialogVisible:false,
      dialogVisibleTwo: false,
      detaillData: {},
      // mineNumberNo: '',
      ruleForm:{
        notes: '',
        nodeNumber: '',
        nodeName: ''
      },
      rules:{
        nodeNumber: [
          { required: true, message: '请输入节点编号', trigger: 'blur' },
        ],
        nodeName:[
            { required: true, message: '请输入节点名称', trigger: 'blur' }
        ],
      },
    };
  },
  created() {
    this.getTableList()
  },
  methods: {
    async ChangeTypeIsDel(row){
      console.log(row)
      let data= {
        minerNodeId: row.minerNodeId,
        isPackage: row.isDelCheck?1:0,
        isSell: row.isSellCheck?1:0
      }
      let res = await this.$http.updateNode(data);
      if (res) {
        this.$message.success('操作成功！');
        this.getTableList()
      } 
    },
    ChangeTypeisSell(row){
      console.log(row)
    },
    // 查看详情
    goDetaill(row) {
      this.detaillData = row
      this.dialogVisibleTwo = true
    },
    getCent(row) {
      sessionStorage.setItem("minerCode", row.nodeNumber);
      this.$router.push({ name: 'centsAuditNew'});
    },
    resetForm(formName) {
        this.$refs[formName].resetFields();
      },
    getNumber (num) {
      return num.toFixed(2)
    },
    cancel(row) {
      let _this = this
      sessionStorage.setItem("minerNodeId", row.minerNodeId);
      this.$router.push({ name: 'minercodeDetail'});
    },
    submitForm(formName) {
      let _this = this
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          let res = await this.$http.saveOrUpdate({...this.ruleForm});
          if (res) {
            this.$message.success('操作成功！');
            this.dialogVisible=false;
            this.$nextTick(() => {
              this.$refs['ruleForm'].resetFields()
            })
            this.getTableList()
          }
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    addFunc(){
      // this.ruleForm.notes = ''
      // this.ruleForm.nodeNumber = ''
      // this.ruleForm.nodeName = ''
      this.dialogVisible=true;
      this.$nextTick(() => {
        this.$refs['ruleForm'].resetFields()
      })
    },
    async getTableList(val){
      if(val){
        this.searchForm.page=1;
      }
       let res = await this.$http.nodeList({...this.searchForm});
        if (res) {
          this.tableData=res.data.list.map(x=>{
              if(x.isPackage==1){
                x.isDelCheck=true
              } else {
                x.isDelCheck=false
              }
              if(x.isSell==1){
                x.isSellCheck=true
              } else {
                x.isSellCheck=false
              }
              return x
          })
          console.log(this.tableData)
          this.totalNum = Number(res.data.totalSize)
        }
    },
    handleSizeChange(val) {
      this.searchForm.page = 1;
      this.searchForm.pageSize = val;
      this.getTableList();
    },
    handleCurrentChange(val) {
      this.searchForm.page = val;
      this.getTableList();
    }
  }
};
</script>

<style scoped>
.saml_box{
  margin-bottom: 20px;
}
.decBox{
  margin-top: 20px;
}
.dec_title{
  font-size: 14px;
  font-weight: bold;
  margin-bottom: 20px;
}
</style>
